/** Workload shape: mostly CPU-bound API vs heavier compute / payloads (GPU-style heuristic). */
export type ComputeProfileId = "cpu" | "gpu";

export const DEFAULT_COMPUTE_PROFILE: ComputeProfileId = "cpu";

export function normalizeComputeProfile(x: unknown): ComputeProfileId {
  if (x === "gpu") return "gpu";
  return "cpu";
}

/**
 * GPU-style: bump Lambda proxy (duration/memory class) and egress slightly.
 * Indicative only — not SageMaker / EC2 G-instance line items.
 */
export function computeProfileFactors(id: ComputeProfileId): {
  lambdaMult: number;
  transferMult: number;
} {
  if (id === "gpu") {
    return { lambdaMult: 2.35, transferMult: 1.12 };
  }
  return { lambdaMult: 1, transferMult: 1 };
}
